<script module>
  import { _ } from 'svelte-i18n';
  import favicon from '$lib/assets/favicon.png';
  import logoUrl from '$lib/assets/logo.png';
</script>

<svelte:head>
  <link rel="icon" href={favicon} />
</svelte:head>

<script>
  import '$lib/style.css';
  let { children } = $props();
</script>

<section class="page">
   <header class="header">
     <img id="bot-pic" src={logoUrl} alt="Nemambyt Logo">
     <h1 id="title"><a class="header-link" href="/">NemamByt</a></h1>
     <h3 class="hint" id="subtitle">
       {$_('page.subtitle', { default: 'Real estate search in Prague' })}
     </h3>
   </header>

   <main id="main">
    {@render children()}
   </main>
</section>
